<template>
    <section class="w-full">
        <p v-if="label" class="eyebrow text-ink-muted mb-4">{{ label }}</p>
        <YSectionHeader v-if="title" :title="title"/>
        <slot/>
    </section>
</template>

<script lang="ts" setup>
// A content block in the Swiss idiom: a ruled heading instead of a box, no fill or shadow.
defineProps<{
    title?: string,
    label?: string,
}>()
</script>
